import { render, staticRenderFns } from "./PortalsList.vue?vue&type=template&id=6f6d3196&"
import script from "./PortalsList.vue?vue&type=script&lang=js&"
export * from "./PortalsList.vue?vue&type=script&lang=js&"
import style0 from "./PortalsList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PortalsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports